<template>
    <div class="check-list-box">
        <div class="check-all"><el-checkbox label="全选" @change="checkAll" v-model="column.checked"></el-checkbox></div>
        <div class="check-list">
            <el-checkbox v-for="item in column.data" v-model="item.checked"
            :key="item.id||item.value||item[column.key]" 
            :label="item.name||item.label||item[column.value]"></el-checkbox>
        </div>
    </div>
</template>
<script>
export default {
    props:['column'],
    methods:{
        checkAll(){
            if(this.column.checked){
                this.column.data.map(item => {
                    item.checked = true;
                });
            }else{
                this.column.data.map(item => {
                    item.checked = false;
                });
            }
        },
        setValue(){
            this.column.checked = false;
            let formModel = this.$store.state[this.$utils.storeKeys.CURRENTFORM];
            let columnData = formModel[this.column.prop]||[];
            this.column.data.map(item => {
                item.checked = false;    
                if(columnData.filter(data=>{return data==item.id}).length>0)
                    item.checked = true;
            });
        },
        getFormData(){
            let checkList = [];
            this.column.data.map(item => {
                if(item.checked){
                    checkList.push(item);
                }
            });
            this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
                    key: this.column.prop,
                    value: checkList
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/controls/checkList.vue